export const HOST = "https://polywinegypt.com";
export const TOKEN_STORAGE = "token";
